<template>
  <div class="px3">
    <div class="bb-h60vh">
      <div class="center clearfix relative bb-vcr">
        <div class="bb-ff2 bb-fs2pt17 bb-fc1">FAILED</div>
        <div class="mt2 bb-ff2 bb-fs1pt13 bb-fc3 bb-lh1pt5 bb-mx2 bb-sm-mx10 bb-md-mx1">
          {{ $lang.messages.pay_app }}
        </div>
        <div class="bb-mt2pt56 mx-auto bb-w12">
          <router-link to="/" class="text-decoration-none border-none">
            <div class="center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp
            bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3 bb-h2pt5 bb-py1pt25 bb-lh0
            bb-transition2">
            {{ $lang.messages.retry }}
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paymentFail'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/paymentFail.vue